<mat-form-field appearance="outline" class="w-100 form">
    @if(label){
        <mat-label>{{label}}</mat-label>
    }
    <mat-select [(ngModel)]="preSelectedLanguage" placeholder="{{placeholder}}"
        [formControl]="selectedLanguageControl" required
        data-testid="language-select"
        (selectionChange)="emitLanguageChange($event.value)">
        @for (language of languages; track language) {
            <mat-option value="{{language.code}}" [value]="language.code" [disabled]="language.code === preSelectedLanguage"
                [attr.data-testid]="'language-option-' + language.code">
                {{ language.name | translate }}
            </mat-option>
        }
    </mat-select>
    <mat-error *ngIf="getErrorMessage()" class="error-container">
        <mat-icon svgIcon="info_error" class="icon"></mat-icon>
        <span class="pl-8">{{ getErrorMessage() | translateWithKeys }}</span>
    </mat-error>
</mat-form-field>